import { stripUrlParams } from "utils/utils";

/** Formats every supported browser renders natively in an <img>. HEIC and TIFF are left out on purpose. */
const PREVIEWABLE_IMAGE_EXTENSIONS = new Set([
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "bmp",
  "svg",
  "avif",
]);

const PREVIEWABLE_IMAGE_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/bmp",
  "image/svg+xml",
  "image/avif",
]);

const extensionOf = (url) => {
  const path = stripUrlParams(url);
  const dot = path.lastIndexOf(".");
  return dot === -1 || path.lastIndexOf("/") > dot ? "" : path.slice(dot + 1).toLowerCase();
};

/**
 * Whether an attachment can be shown inline as an image. A known content type wins over the file
 * extension, since stored keys do not always keep one.
 */
export const isPreviewableImage = (url, contentType) => {
  if (!url) return false;
  if (contentType) return PREVIEWABLE_IMAGE_TYPES.has(String(contentType).toLowerCase());
  return PREVIEWABLE_IMAGE_EXTENSIONS.has(extensionOf(url));
};
